import React, { useState, useEffect } from 'react'
import { FileUploadService } from '../../../_services/CommnService/FileUploadService/FileUploadService'
import { CommonApiService } from '../../../_services/CommnService/CommonApiService'
import toastr from 'toastr'
import DropDown from '../../../_components/_common/DropDown/DropDown'
import { Validation } from '../../../_helpers/validation/Validation'
import LoaderWithLogo from '../../../_components/Loader/LoaderWithLogo'
import farmerkyc from "../../../assets/images/farmer.png";
import traderkyc from "../../../assets/images/trader.png";
import fpokyc from "../../../assets/images/FPO.png";
import privatekyc from "../../../assets/images/private.png";
import multiplekyc from "../../../assets/images/multiowner.png";
import prokyc from "../../../assets/images/propeiter.png";
import partnerkyc from "../../../assets/images/hand-shake.png";
import mnckyc from "../../../assets/images/mnc.png";
import bankkyc from "../../../assets/images/bank.png";
import govagencykyc from "../../../assets/images/govagency.png";
import { AiFillExclamationCircle } from "react-icons/ai";
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'

const LoginEnterDetails = (props) => {
  // const [userType, setUserType] = useState([])
  const [type, setType] = useState("")
  const [stateArray, setStateArray] = useState([])
  const [state, setStates] = useState("")
  const [pan, setPan] = useState("")
  const [aadhaar, setAadhaar] = useState("")
  const [isLoading, setLoader] = useState(false)
  const [error, setError] = useState("")
  const [aadhaarFrontImage, setAadhaarFrontImage] = useState("")
  const [aadhaarBackImage, setAadhaarBackImage] = useState("")
  const [aadhaarFrontImageBase64, setAadhaarFrontImageBase64] = useState("")
  const [aadhaarBackImageBase64, setAadhaarBackImageBase64] = useState("")
  const [isComingFromLast, setIsComingFromLast] = useState(false)
  const [isAadhaarOrPan, setIsAadhaarOrPan] = useState("")
  const farmerAndRetailerType=(type === "FARMERS" || type ==='Retailer');
  useEffect(() => {
    if (Array.isArray(stateArray) && stateArray.length === 0) {
      getState()
    }
  }, [props.dataForSignUp])


  useEffect(() => {
    if (type) {
      setLoader(true)
      CommonApiService.userType({ "user_type": type }).then(res => {
        setLoader(false)
        if (props.noKYC) {
          props.close()
        }
      }).catch(() => {
        setLoader(false)
      })
    }
  }, [type])

  useEffect(() => {
    if (props.yourDetails) {
      setIsComingFromLast(true)
      setPan(props.yourDetails.pan_number ? props.yourDetails.pan_number : "")
      setStates(props.yourDetails.state)
      let err = { pan_number: props.penError ? props.penError : "" }
      if (props.penError) {

        setError(err)
      }
      let adharErr = { aadhar_number: props.aadhaarError }
      if (props.aadhaarError) { setError(adharErr) }
      let adharErr2 = { aadhaarFrontImage: props.aadharError2 }
      if (props.aadharError2) { setError(adharErr2) }
      setAadhaar(props.yourDetails.aadhar_number ? props.yourDetails.aadhar_number : "")

      setTimeout(() => {
        setType(props.yourDetails.user_type)
        setIsComingFromLast(false)
        setIsAadhaarOrPan(props.yourDetails.aadhar_number ? "aadhaar" : "pan")
      }, 200)
    }
  }, [props.yourDetails])

  useEffect(() => {
    if (!farmerAndRetailerType && type !== "") {
      setAadhaarFrontImage("")
      setAadhaarBackImage("")
      setAadhaarFrontImageBase64("")
      setAadhaarBackImageBase64("")
      setIsAadhaarOrPan("")
    }
    if (type !== "") {
      props.onChangeType(type)
      setError("")
    }
  }, [type])

  useEffect(() => {
    if (!isComingFromLast) {
      setAadhaarFrontImage("")
      setType("")
      setPan("")
      setStates("")
      setAadhaar("")
      setIsAadhaarOrPan("")
      props.onChangeType("")
    }
  }, [props.type])

  const getState = async () => {
    await CommonApiService.getStatesOfCountry().then(response => {
      if (response && response.data && response.data.data) {
        let stateArr = [{ value: null, label: "Please Select State ..." }].concat(response.data.data)
        setStateArray(stateArr)
      }
    })
  }

  const onchangeState = (e) => {
    setStates(e.value)
  }

  const onSubmit = () => {
    if (!farmerAndRetailerType) {
      setAadhaar("")
      setAadhaarFrontImage("")
      setAadhaarFrontImageBase64("")
    }
    let flag = 0
    let data = {
      "pan_number": isAadhaarOrPan === "pan" && pan ? pan : null,
      "aadhar_number": isAadhaarOrPan === "aadhaar" && aadhaar ? aadhaar : "",
      //"gstin_number": gstNo ? gstNo : null,
      "user_type": type,
      // "address": address,
      "state": isAadhaarOrPan === "pan" && state,
      //"district": city,
      // "pincode": pincode,
      "pan_image": "",
      "aadhar_front_image": isAadhaarOrPan === "aadhaar" && aadhaar && aadhaarFrontImage ? aadhaarFrontImage : "",
      "aadhar_back_image": aadhaarBackImage ? aadhaarBackImage : "",
      aadhaarFrontImageBase64: isAadhaarOrPan === "aadhaar" && aadhaar ? aadhaarFrontImageBase64 : "",
      aadhaarBackImageBase64: aadhaarBackImageBase64
    }
    let obj = Validation(data, rules)

    if (type !== "") {
      if (farmerAndRetailerType) {
        if (aadhaar === "" && aadhaarFrontImage !== "") {
          obj.aadhar_number = "Aadhaar Number is Required!";
        }
        if (aadhaar !== "" && aadhaarFrontImage === "" && isAadhaarOrPan === "aadhaar") {
          obj.aadhaarFrontImage = "Aadhaar Front Image is Required!";
        }
        if (pan === "" && aadhaarFrontImage === "" && aadhaarBackImage === "") {
           if(isAadhaarOrPan === "pan")
             obj.pan_number = `${farmerAndRetailerType ? "" : 'Business'} PAN Number is Required!`;
          else if(aadhaarFrontImage === "")
            obj.aadhar_number = "Aadhaar Image/Aadhar Number is Required!";
          else
          obj.aadhar_number = "Aadhaar Number is Required!";
          
          // toastr.info(isAadhaarOrPan === "pan" ? "PAN Number is Required!" : "Aadhaar Number is Required!")
        }
      } else {
        if (pan === "") {
          obj.pan_number = "Business PAN is Required!";
        }
      }
    }

    setError(obj)
    Object.keys(obj).forEach(index => {
      if (obj[index] !== "") {
        flag = 1;
      }
    });
    if (flag === 0) {
      props.pageDetails(data)
    }
  }

  const handleChange = (e, callFunction, setBase64) => {
    setLoader(true)
    var fileList = e.target.files;
    let type_temp = fileList[0].name.split('.')
    let filesize = fileList[0].size
    let type = type_temp[type_temp.length - 1]
    let extention = ['jpg', 'JPG', 'png', 'PNG', 'jpeg', 'JPEG']
    if (extention.includes(type) && filesize < 2048000) {
      var filecontainer = [];
      for (var i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          setBase64(reader.result)
          filecontainer.push(reader.result);
          if (filecontainer.length === fileList.length) {
            uploadImages(filecontainer, callFunction);
          }
        };
        reader.onerror = function (error) {
          toastr.error("please upload valid file")
          setLoader(false)
        }
      }
    } else {
      toastr.warning("Please Upload Valid Image and Max Size Should be 2MB")
      setLoader(false)
    }
  }

  const uploadImages = async (files, callFunction) => {
    setLoader(true)
    let imgarr = [];
    let uploadeds3link = [];
    for (var i = 0; i < files.length; i++) {
      var fileobj = {
        "path": "arya/warehouseRequests/",
        "file": files[i]
      }
      var apiresponse = await FileUploadService.fileUloadService(fileobj);
      if (apiresponse !== null && apiresponse.data.data.file_path) {
        var objimg = {
          "src": apiresponse.data.data.file_path,
          "thumbnail": apiresponse.data.data.file_path,
          "thumbnailWidth": 100,
          "thumbnailHeight": 100
        }
        imgarr.push(objimg);
        uploadeds3link.push(apiresponse.data.data.file_path);
        console.log(imgarr, "kkkkkkk", apiresponse)
      }
      setLoader(false)
    }
    callFunction(uploadeds3link[0])
    console.log(imgarr, "kkkkkkk1", uploadeds3link[0])
  }

  const onKeyPressSubmit = (e) => {
    if (e.key === 'Enter')
      onSubmit()
  }
  
  return <div className="filterbx p-0">
    <LoaderWithLogo isLoading={isLoading}></LoaderWithLogo>

    <div className="radioselectuser">
      <div className="select-title">
        {!props.noKYC && <h3>User Type - {type}</h3>}
      </div>
      <div className="selectradio">
        {(type === "") && <div className="selectoption" onClick={() => setType('FARMERS')}>
          <input type="radio" name="selectuser" value="Farmers" checked={type === "FARMERS"} />
          <label for="Farmers">
            <span><MultiLanguageTranslation title="Farmers" /></span>
            <img alt="" src={farmerkyc} className="farmer_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('TRADERS')}>
          <input type="radio" name="selectuser" value="Traders" checked={type === "TRADERS"} />
          <label for="Traders">
            <span><MultiLanguageTranslation title="Traders" /></span>
            <img alt="" src={traderkyc} className="trader_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('FPO')} >
          <input type="radio" name="selectuser" value="FPO" checked={type === "FPO"} />
          <label for="FPO">
            <span><MultiLanguageTranslation title="FPO" /></span>
            <img alt="" src={fpokyc} className="fpo_kyc" />
          </label>
        </div>}

        {(type === "") && <div className="selectoption" onClick={() => setType('SME')}>
          <input type="radio" name="selectuser" value="SME" checked={type === "SME"} />
          <label for="SME">
            <span><MultiLanguageTranslation title="SME" /></span>
            <img alt="" src={privatekyc} className="SME" />
          </label>
        </div>}

        {(type === "") && <div className="selectoption" onClick={() => setType('Corporate')}>
          <input type="radio" name="selectuser" value="Corporate" checked={type === "Corporate"} />
          <label for="Corporate">
            <span><MultiLanguageTranslation title="Corporate" /></span>
            <img alt="" src={prokyc} className="proprietor_kyc" />
          </label>
        </div>}

        {(type === "") && <div className="selectoption" onClick={() => setType('Retailer')}>
          <input type="radio" name="selectuser" value="Retailer" checked={type === "Retailer"} />
          <label for="Retailer">
            <span><MultiLanguageTranslation title="Retailer" /></span>
            <img alt="" src={prokyc} className="proprietor_kyc" />
          </label>
        </div>}


        {/* {(type === "") && <div className="selectoption" onClick={() => setType('PRIVATE LTD')}>
          <input type="radio" name="selectuser" value="private" checked={type === "PRIVATE LTD"} />
          <label for="private">
            <span><MultiLanguageTranslation title="Private Ltd" /></span>
            <img alt="" src={privatekyc} className="private_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('MULTIPLE OWNER')}>
          <input type="radio" name="selectuser" value="MultipleOwner" checked={type === "MULTIPLE OWNER"} />
          <label for="MultipleOwner">
            <span><MultiLanguageTranslation title="Multiple Owner" /></span>
            <img alt="" src={multiplekyc} className="multiple_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('PROPRITER')}>
          <input type="radio" name="selectuser" value="Propriter" checked={type === "PROPRITER"} />
          <label for="Propriter">
            <span><MultiLanguageTranslation title="Propriter" /></span>
            <img alt="" src={prokyc} className="proprietor_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('PATNERSHIP')}>
          <input type="radio" name="selectuser" value="Patnership" checked={type === "PATNERSHIP"} />
          <label for="Partnership">
            <span><MultiLanguageTranslation title="Partnership" /></span>
            <img alt="" src={partnerkyc} className="partner_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('MNCs')}>
          <input type="radio" name="selectuser" value="mncs" checked={type === "MNCs"} />
          <label for="mncs">
            <span><MultiLanguageTranslation title="MNCs" /></span>
            <img alt="" src={mnckyc} className="mnc_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('Banks')}>
          <input type="radio" name="selectuser" value="Banks" checked={type === "Banks"} />
          <label for="Banks">
            <span><MultiLanguageTranslation title="Banks" /></span>
            <img alt="" src={bankkyc} className="bank_kyc" />
          </label>
        </div>}
        {(type === "") && <div className="selectoption" onClick={() => setType('Govt Agencies')}>
          <input type="radio" name="selectuser" value="Govagency" checked={type === "Govt Agencies"} />
          <label for="Govagency">
            <span><MultiLanguageTranslation title="Govt Agency" /></span>
            <img alt="" src={govagencykyc} className="govagency_kyc" />
          </label>
        </div>} */}
      
      </div>
    </div>

    {farmerAndRetailerType && <div className="form-group mt-4">
      <div className="farmer_aadhar">
        <div className="farmer_aadhar_radio">
          <input type="radio" onKeyPress={onKeyPressSubmit} name="fa-pan_radio" checked={isAadhaarOrPan === "aadhaar"} onClick={() => setIsAadhaarOrPan("aadhaar")}></input>
        </div>
        <div className="poxlogin">
          <input
            name="first_name"
            type="text"
            className={error && error.aadhar_number && error.aadhar_number !== "" ? "poxinput-error" : "poxinput"}
            id=""
            onChange={e => setAadhaar(e.target.value.toString().length <= 12 ? e.target.value : aadhaar, setIsAadhaarOrPan("aadhaar"))}
            onKeyPress={onKeyPressSubmit}
            // placeholder="Aadhaar Number"
            value={aadhaar}
            required
          // readOnly={isAadhaarOrPan === ""}
          />
          {error && error.aadhar_number && error.aadhar_number !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>}
          <label className={error && error.aadhar_number && error.aadhar_number !== "" ? "poxlabel-error" : "poxlabel"}>Your Aadhaar Number</label>
          {error && error.aadhar_number !== "" && (
            <div className="fromerror">{error.aadhar_number}</div>)}
        </div>
      </div>
    </div>}

    {farmerAndRetailerType && <div className="form-group pologin_label">
      <label><MultiLanguageTranslation title="Upload Front Image of Aadhaar" /></label>
      <div >
        <div>
          <div className="file-input KYCfileUpload">
            <input type="file" multiple onChange={(e) => handleChange(e, setAadhaarFrontImage, setAadhaarFrontImageBase64)} id={"custom-fileUpload" + 2} />
          </div>
          <p style={{ fontSize: '12px', textAlign: 'center' }}><MultiLanguageTranslation title="(Max File Size Limit: 2MB and Only JPEG/JPG/PNG)" /></p>
          {aadhaarFrontImage && <div style={{ position: 'relative', bottom: '18px' }}>{aadhaarFrontImage.substring(aadhaarFrontImage.length - 18, aadhaarFrontImage.length)}</div>}
          {error && error.aadhaarFrontImage !== "" && (
            <div className="fromerror" style={{ position: 'relative', bottom: '18px' }}>{error.aadhaarFrontImage}</div>)}
        </div>
      </div>

    </div>}
    {farmerAndRetailerType && isAadhaarOrPan === "" && <div className="text-center">
      <hr style={{ borderTop: '1px dashed #000' }} />
    </div>}

    {type !== "" && <div className="form-group mt-4">
      <div className="farmer_aadhar">
        {farmerAndRetailerType && <div className="farmer_aadhar_radio">
          <input type="radio" name="fa-pan_radio" checked={isAadhaarOrPan === "pan"} onClick={() => setIsAadhaarOrPan("pan")} onKeyPress={onKeyPressSubmit}></input>
        </div>}
        <div className="poxlogin" style={farmerAndRetailerType ? {} : { width: '100%' }}>
          <input
            name="first_name"
            type="text"
            className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
            id=""
            onChange={e => setPan(e.target.value.toUpperCase(), setIsAadhaarOrPan("pan"))}
            onKeyPress={onKeyPressSubmit}
            value={pan}
            required
          // readOnly={isAadhaarOrPan === ""}
          />
          {error && error.pan_number && error.pan_number !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>}
          <label className={error && error.pan_number && error.pan_number !== "" ? "poxlabel-error" : "poxlabel"}>Your {farmerAndRetailerType ? "" : "Business"} PAN Number</label>
          {error && error.pan_number !== "" && (
            <div className="fromerror">{error.pan_number}</div>)}
        </div>
      </div>
    </div>
    }

    {type !== "" && !farmerAndRetailerType && <div className="form-group mt-4 pologin">
      <div className="polabel">If Registered for GST, Please Choose Your State</div>
      {stateArray && <DropDown preselected={state} options={stateArray} onChange={onchangeState} isDisabled={isAadhaarOrPan === ""} onKeyPress={onKeyPressSubmit} />}
      {error && error.state !== "" && (
        <div className="fromerror">{error.state}</div>)}
    </div>
    }
    {type !== "" && isAadhaarOrPan !== "" && <div className="mt-4">
      <a className="form-control posubmit" style={{ backgroundColor: "#e08701", textAlign: 'center', color: "#fff", fontWeight: '600', cursor: 'pointer' }} onClick={() => onSubmit()}>CONTINUE</a>
    </div>}
  </div>
}
export default LoginEnterDetails

const rules = [{
  field_name: 'user_type',
  label: 'User Type',
  type: "string",
  isRequired: true
},
{
  field_name: 'pan_number',
  label: 'PAN Number',
  type: "pan",
  isRequired: false
},
{
  field_name: 'aadhar_number',
  label: 'Aadhaar Number',
  type: "number",
  min: 12,
  max: 12,
  isRequired: false
},]